import {
  SITE_ADMIN_TABS,
  filterVisibleSiteAdminTabs,
  type FilterSiteAdminTabsOptions,
  type Permission,
  type SiteAdminLink,
  type SiteAdminSection,
  type SiteAdminTab,
} from '@lms/shared-types';

export type { FilterSiteAdminTabsOptions, SiteAdminLink, SiteAdminSection, SiteAdminTab };
export { SITE_ADMIN_TABS };

export function filterVisibleTabs(
  hasPermission: (p: Permission) => boolean,
  options?: FilterSiteAdminTabsOptions,
) {
  return filterVisibleSiteAdminTabs(hasPermission, options);
}
